import Margin from './Margin/index.js';
import HorizontalDivider from './HorizontalDivider/index.js';

var Spacing = {
  HorizontalDivider: HorizontalDivider,
  Margin: Margin
};

export { Spacing as default };
//# sourceMappingURL=index.js.map
